import React from "react";
import { collectionsData } from "../data/data";
import { useParams } from "react-router-dom";

function Artist() {
    // Whose page should we load?
  const { name } = useParams();

  // Get corresponding data
  const collection = collectionsData.find((collection) => collection.name === name);

  return (
    <section>
      <h2>{collection.name}</h2>
      <p>{collection.descriptionExtended}</p>
    </section>
  );
}

export default Artist;